import { FormattedMessage } from 'react-intl';

import { LINK_FOR_SEARCH_API_DOCS } from 'constants/globals';
import thematize from 'lib/thematize';
import { useCustomRouterLocation, useNavigate, useSelector, useUser } from 'hooks';
import { Tab, TabItem, TabsContainer } from 'components/Tabs';
import messages from './messages';
import Stats from './Stats';
import Token from './Token';
import styles from './ManageToken.scss';

const theme = thematize(styles);

const ManageToken = () => {
  const navigate = useNavigate();
  const location = useCustomRouterLocation();
  const user = useUser();
  const locale = useSelector(({ app }) => app.user.settings.language) as 'en' | 'ru';
  const activeTab = location.hash || '#token';
  const isSearchApiEnabled = !!user.company.searchApiAccess;
  const docsLink = LINK_FOR_SEARCH_API_DOCS[locale] || LINK_FOR_SEARCH_API_DOCS.en;

  const handleTabSelect = (hash: string): void => {
    navigate({ ...location, hash, replace: true });
  };

  return (
    <div className={theme('container')}>
      <div className={theme('heading')}>
        <FormattedMessage {...messages.heading} />
      </div>
      <div className={theme('search-api', { disabled: !isSearchApiEnabled })}>
        <FormattedMessage
          {...messages[isSearchApiEnabled ? 'searchApiEnabled' : 'searchApiDisabled']}
          values={{
            code: (chunks) => <code>{chunks}</code>,
          }}
        />{' '}
        <FormattedMessage
          {...messages.searchApiDocs}
          values={{
            link: (chunks) => (
              <a href={docsLink} target="_blank" rel="noopener noreferrer">
                {chunks}
              </a>
            ),
          }}
        />
      </div>
      <TabsContainer selectedTab={activeTab} onTabSelect={handleTabSelect}>
        <TabItem
          id="token"
          title={
            <Tab>
              <FormattedMessage {...messages['accessToken']} />
            </Tab>
          }
          content={<Token />}
        />
        <TabItem
          id="stats"
          title={
            <Tab>
              <FormattedMessage {...messages['stats']} />
            </Tab>
          }
          content={<Stats />}
        />
      </TabsContainer>
    </div>
  );
};

export default ManageToken;
